module.exports = __webpack_public_path__ + "media/images/white-logo-7c184dcd693411e42ffedad004ff03cd.svg";